// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { toast } from "react-toastify";
// import { 
//   Users, CheckCircle2, Clock, Eye, 
//   Award, X, Search, Star, Download, Filter, ArrowRight
// } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import ModernTable from "../ui/ModernTable";

// // Helper to format system DB cycle keys to user-friendly labels
// const formatCycleDisplay = (cycle) => {
//   const mapping = {
//     "1_WEEK": "Weekly",
//     "2_WEEKS": "Bi-weekly",
//     "1_MONTH": "Monthly",
//     "2_MONTHS": "Bi-monthly",
//     "3_MONTHS": "Quarterly",
//     "6_MONTHS": "Half-Yearly",
//     "12_MONTHS": "Annual"
//   };
//   return mapping[cycle] || cycle;
// };

// // Helper function to resolve KRA achievement rating based on image grading scale
// const getAchievementRating = (percentage) => {
//   if (percentage === null || percentage === undefined || isNaN(percentage)) return "N/A";
//   if (percentage >= 110) return "Outstanding";
//   if (percentage >= 100) return "Exceeds Expectations";
//   if (percentage >= 90) return "Meets Expectations";
//   if (percentage >= 75) return "Needs Improvement";
//   return "Unsatisfactory";
// };

// // Helper function to return beautiful styling badge classes
// const getRatingBadgeClass = (rating) => {
//   switch (rating) {
//     case "Outstanding": return "bg-emerald-100 text-emerald-800 border-emerald-200";
//     case "Exceeds Expectations": return "bg-teal-50 text-teal-700 border-teal-200";
//     case "Meets Expectations": return "bg-blue-50 text-blue-700 border-blue-200";
//     case "Needs Improvement": return "bg-amber-50 text-amber-700 border-amber-200";
//     case "Unsatisfactory": return "bg-red-50 text-red-700 border-red-200";
//     default: return "bg-gray-50 text-gray-700 border-gray-200";
//   }
// };

// export default function KraReviewsList() {
//   const [loading, setLoading] = useState(true);
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);
//   const [selectedEmployeeAppraisals, setSelectedEmployeeAppraisals] = useState(null); 
//   const [activeStageTab, setActiveStageTab] = useState("");
//   const [skippingId, setSkippingId] = useState(null); 

//   // Filters Master lists state
//   const [departments, setDepartments] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   // Selected Filter States
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState("");

//   // Search & Basic Filter States
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedYear, setSelectedYear] = useState(""); 
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Fetch active structural dependencies for dropdown filters on mount
//   const loadReviewsAndFilters = useCallback(async () => {
//     setLoading(true);
//     try {
//       const url = SummaryApi.listReviewsKra?.url || "/api/hr/kra/reviews/view-all";
//       const [reviewsRes, deptRes, divRes, empRes] = await Promise.all([
//         api.get(url),
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDivisions.url),
//         api.get(SummaryApi.getAllEmployees?.url || "/api/hr/employees/active-list") 
//       ]);

//       if (reviewsRes.data.success) setReviews(reviewsRes.data.data || []);
//       if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (empRes.data.success) setEmployees(empRes.data.data.map(e => ({ label: `${e.firstName} ${e.lastName}`, value: e._id })));
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load active appraisal sheets.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadReviewsAndFilters();
//   }, [loadReviewsAndFilters]);

//   // Reset pagination to first page on filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchQuery, selectedPeriod, selectedYear, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

//   // Extract unique appraisal periods from loaded reviews dataset
//   const periods = useMemo(() => {
//     const list = reviews.map(r => r.period).filter(Boolean);
//     return [...new Set(list)].map(item => ({ label: item, value: item }));
//   }, [reviews]);

//   // Extract unique appraisal years from loaded reviews dataset
//   const years = useMemo(() => {
//     const list = reviews.map(r => r.year).filter(Boolean);
//     return [...new Set(list)].map(item => ({ label: `FY ${item}`, value: item }));
//   }, [reviews]);

//   // Dynamic Metrics & Stats Calculations
//   const stats = useMemo(() => {
//     const totalCount = reviews.length;
//     const completedCount = reviews.filter(r => r.status === "COMPLETED").length;
//     const pendingCount = totalCount - completedCount;

//     const completedReviews = reviews.filter(r => r.status === "COMPLETED");
//     let totalScoreSum = 0;
//     completedReviews.forEach(r => {
//       const latestEval = r.overallEvaluations?.[r.overallEvaluations.length - 1];
//       if (latestEval && latestEval.overallScore) {
//         totalScoreSum += latestEval.overallScore;
//       }
//     });
//     const avgScore = completedReviews.length > 0 ? (totalScoreSum / completedReviews.length).toFixed(2) : "0.00";

//     return { totalCount, completedCount, pendingCount, avgScore };
//   }, [reviews]);

//   // Client-side advanced filtration logic
//   const filteredReviews = useMemo(() => {
//     return reviews.filter(r => {
//       const user = r.userId || {};
//       const fullName = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      
//       const matchesSearch = fullName.includes(searchQuery.toLowerCase()) || 
//                             (user.userId && user.userId.toLowerCase().includes(searchQuery.toLowerCase()));

//       const matchesPeriod = !selectedPeriod || r.period === selectedPeriod;
//       const matchesYear = !selectedYear || selectedYear === "" || Number(r.year) === Number(selectedYear);
//       const matchesStatus = !selectedStatus || r.status === selectedStatus;

//       const uDeptId = user.departmentId?._id || user.departmentId;
//       const uDivId = user.divisionId?._id || user.divisionId;

//       const matchesDepartment = !selectedDepartment || uDeptId === selectedDepartment;
//       const matchesDivision = !selectedDivision || uDivId === selectedDivision;
//       const matchesEmployee = !selectedEmployee || user._id === selectedEmployee;

//       return matchesSearch && matchesPeriod && matchesYear && matchesStatus && matchesDepartment && matchesDivision && matchesEmployee;
//     });
//   }, [reviews, searchQuery, selectedPeriod, selectedYear, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

//   // Grouped filtered reviews dynamically by Employee ID and Year to separate timelines cleanly
//   const employeeGroupedReviews = useMemo(() => {
//     const map = {};
//     filteredReviews.forEach(review => {
//       const empId = review.userId?._id;
//       if (!empId) return;

//       const groupKey = `${empId}_${review.year}`;

//       if (!map[groupKey]) {
//         map[groupKey] = {
//           employee: review.userId,
//           year: review.year, 
//           appraisals: [],
//           completedCount: 0
//         };
//       }
//       map[groupKey].appraisals.push(review);
//       if (review.status === "COMPLETED") {
//         map[groupKey].completedCount += 1;
//       }
//     });

//     return Object.values(map).map(item => {
//       let scoreSum = 0;
//       let scoreCount = 0;
//       item.appraisals.forEach(r => {
//         const latestEval = r.overallEvaluations?.[r.overallEvaluations.length - 1];
//         if (latestEval && latestEval.overallScore) {
//           scoreSum += latestEval.overallScore;
//           scoreCount += 1;
//         }
//       });
//       const avgScore = scoreCount > 0 ? (scoreSum / scoreCount).toFixed(2) : "-";
//       return {
//         ...item,
//         avgScore
//       };
//     });
//   }, [filteredReviews]);

//   // Pagination Logic
//   const paginatedGroupedReviews = useMemo(() => {
//     const startIdx = (currentPage - 1) * itemsPerPage;
//     return employeeGroupedReviews.slice(startIdx, startIdx + itemsPerPage);
//   }, [employeeGroupedReviews, currentPage]);

//   const handleOpenDetailsModal = useCallback((review) => {
//     setSelectedReview(review);

//     if (
//       review.overallEvaluations &&
//       review.overallEvaluations.length > 0
//     ) {
//       setActiveStageTab(review.overallEvaluations[0].stageKey);
//     } else {
//       setActiveStageTab("");
//     }
//   }, []);

//   const isSelfAssessmentStage = useCallback((row) => {
//     const currentStage = row?.stages?.[row.currentStageIndex];
//     if (!currentStage) return false;

//     const stageKey = String(currentStage.stageKey).toLowerCase();
//     const isSelfKey = stageKey.includes("self") || stageKey.includes("employee");

//     const evaluatorId = currentStage.evaluatorId?._id || currentStage.evaluatorId;
//     const userId = row.userId?._id || row.userId;
//     const isSelfEvaluator = evaluatorId && userId && evaluatorId.toString() === userId.toString();

//     return isSelfKey || isSelfEvaluator;
//   }, []);

//   // Resolves the evaluator name dynamically with strict populates check
//   const getEvaluatorName = (stageKey, evaluatorId) => {
//     if (!selectedReview?.stages) return "Evaluator";
    
//     // 1. Searches inside active workflow stages array
//     const stageObj = selectedReview.stages.find(s => s.stageKey === stageKey);
//     if (stageObj?.evaluatorId) {
//       const evalObj = stageObj.evaluatorId;
//       if (evalObj.firstName) {
//         return `${evalObj.firstName} ${evalObj.lastName || ""}`.trim();
//       }
//     }
    
//     // 2. Direct fallback to inline evaluations object
//     if (evaluatorId && typeof evaluatorId === 'object' && evaluatorId.firstName) {
//       return `${evaluatorId.firstName} ${evaluatorId.lastName || ""}`.trim();
//     }
    
//     return "Evaluator";
//   };

//   const handleSkipStage = useCallback(async (review) => {
//     if (review.status === "COMPLETED") {
//       return toast.warning("This review sheet is already completed and locked.");
//     }

//     if (isSelfAssessmentStage(review)) {
//       return toast.error("The Self Assessment stage is mandatory and cannot be skipped.");
//     }

//     const currentStageName = review.stages[review.currentStageIndex]?.stageName || "Active Stage";
//     if (!window.confirm(`Are you sure you want to bypass/skip the current evaluation stage (${currentStageName}) for this employee?`)) {
//       return;
//     }

//     setSkippingId(review._id);
//     try {
//       const url = SummaryApi.skipKraReviewStage?.url || "/api/hr/kra/reviews/skip";
//       const res = await api.post(url, { reviewId: review._id });
//       if (res.data.success) {
//         toast.success("Active review stage bypassed successfully.");
        
//         const updatedReview = res.data.data;
//         setReviews(prev => prev.map(r => r._id === review._id ? updatedReview : r));
        
//         if (selectedEmployeeAppraisals) {
//           setSelectedEmployeeAppraisals(prev => {
//             const updatedAppraisals = prev.appraisals.map(r => r._id === review._id ? updatedReview : r);
//             return { ...prev, appraisals: updatedAppraisals };
//           });
//         }
//         if (selectedReview && selectedReview._id === review._id) {
//           setSelectedReview(updatedReview);
//         }
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to bypass/skip evaluation stage.");
//     } finally {
//       setSkippingId(null);
//     }
//   }, [selectedReview, selectedEmployeeAppraisals, isSelfAssessmentStage]); 

//   const getSelectedReviewActiveWeightageSum = useMemo(() => {
//     if (!selectedReview || !selectedReview.kras) return 100;
//     return selectedReview.kras.reduce((sum, k) => sum + Number(k.weightage || 0), 0);
//   }, [selectedReview]);

//   // Main columns representing unique employees summary
//   const columns = useMemo(() => [
//     {
//       key: "employee",
//       label: "Employee Profile",
//       render: (row) => {
//         const user = row.employee || {};
//         return (
//           <div className="flex items-center gap-3">
//             {user.profilePicture ? (
//               <img src={user.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
//             ) : (
//               <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 text-[10px] font-bold shrink-0">
//                 {user.firstName?.[0] || ""}{user.lastName?.[0] || ""}
//               </div>
//             )}
//             <div>
//               <p className="font-bold text-slate-900 whitespace-nowrap text-left">{user.firstName} {user.lastName}</p>
//               <p className="text-[10px] text-slate-400 font-medium whitespace-nowrap text-left">{user.email}</p>
//             </div>
//           </div>
//         );
//       }
//     },
//     {
//       key: "employeeId",
//       label: "Employee ID",
//       render: (row) => {
//         const user = row.employee || {};
//         return <span className="font-semibold text-slate-500 whitespace-nowrap">{user.userId || "EMP-N/A"}</span>;
//       }
//     },
//     {
//       key: "year",
//       label: "Appraisal Year",
//       render: (row) => (
//         <span className="font-bold text-slate-700 whitespace-nowrap bg-slate-50 border px-2.5 py-1 rounded-lg">
//           FY {row.year}
//         </span>
//       )
//     },
//     {
//       key: "department",
//       label: "Department & Title",
//       render: (row) => {
//         const user = row.employee || {};
//         return (
//           <div className="text-left whitespace-nowrap">
//             <p className="text-xs font-semibold text-slate-700 leading-tight">{user.departmentId?.name || "N/A"}</p>
//             <p className="text-[10px] text-slate-400 font-medium mt-0.5">{user.designationId?.title || "N/A"}</p>
//           </div>
//         );
//       }
//     },
//     {
//       key: "appraisalCount",
//       label: "Appraisals Group Info",
//       render: (row) => (
//         <span className="text-slate-600 font-bold whitespace-nowrap">
//           {row.completedCount} / {row.appraisals.length} Completed
//         </span>
//       )
//     },
//     {
//       key: "avgScore",
//       label: "Average Score",
//       headerAlign: "center",
//       render: (row) => {
//         if (row.avgScore === "-") {
//           return <div className="text-center text-slate-400 font-semibold">-</div>;
//         }
//         const isOutOfFive = parseFloat(row.avgScore) <= 5;
//         return (
//           <div className="flex justify-center">
//             <span className="flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-2 py-0.5 rounded-lg text-xs">
//               <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
//               {row.avgScore} {isOutOfFive ? "/ 5" : ""}
//             </span>
//           </div>
//         );
//       }
//     }
//   ], []);

//   const tableActions = useMemo(() => [
//     {
//       label: "Manage Appraisals",
//       icon: <Eye className="w-4 h-4 text-slate-500" />,
//       onClick: (row) => {
//         setSelectedEmployeeAppraisals(row); 
//       }
//     }
//   ], []);

//   const resetAllFilters = () => {
//     setSelectedDepartment("");
//     setSelectedDivision("");
//     setSelectedEmployee("");
//     setSelectedPeriod("");
//     setSelectedYear("");
//     setSelectedStatus("");
//     setSearchQuery("");
//   };

//   if (loading) return <PageLoader />;

//   return (
//     <>
//     <div className="space-y-4 animate-in fade-in duration-300">
      
//       {/* HEADER CONTROLS */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div className="text-left">
//           <h1 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight">KRA Appraisal Reviews</h1>
//           <p className="text-xs text-slate-400 mt-1">Monitor ongoing appraisals, scores, and evaluation feedback across stages.</p>
//         </div>
//       </div>

//       {/* STATS ROW */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-blue-50 border border-blue-100 rounded-full flex items-center justify-center text-blue-600 shrink-0">
//             <Users className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Total Appraisals</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.totalCount}</p>
//             <span className="text-[10px] text-slate-400 font-semibold">Initiated Cycles</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-green-50 border border-green-100 rounded-full flex items-center justify-center text-green-600 shrink-0">
//             <CheckCircle2 className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Completed</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.completedCount}</p>
//             <span className="text-[10px] text-green-600 font-semibold">Fully Approved & Closed</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-amber-50 border border-amber-100 rounded-full flex items-center justify-center text-amber-600 shrink-0">
//             <Clock className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">In Progress</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.pendingCount}</p>
//             <span className="text-[10px] text-amber-600 font-semibold">Awaiting Assessments</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-pink-50 border border-pink-100 rounded-full flex items-center justify-center text-pink-500 shrink-0">
//             <Star className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Average Score</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.avgScore}</p>
//             <span className="text-[10px] text-slate-400 font-semibold">Weighted Evaluations Tracker</span>
//           </div>
//         </div>
//       </div>

//       {/* ADVANCED FILTER BOARD */}
//       <div className="bg-white border rounded-xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.02)] space-y-4">
//         <div className="flex flex-wrap items-center gap-4">
//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Year</span>
//             <SelectDropdown options={years} value={selectedYear} onChange={setSelectedYear} placeholder="All Years" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Period</span>
//             <SelectDropdown options={periods} value={selectedPeriod} onChange={setSelectedPeriod} placeholder="All Periods" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Status</span>
//             <SelectDropdown options={[{ label: "Completed", value: "COMPLETED" }, { label: "In Progress", value: "UNDER_REVIEW" }, { label: "Draft", value: "DRAFT" }]} value={selectedStatus} onChange={setSelectedStatus} placeholder="All Status" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Division</span>
//             <SelectDropdown options={divisions} value={selectedDivision} onChange={setSelectedDivision} placeholder="All Divisions" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Department</span>
//             <SelectDropdown options={departments} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Employee Selection</span>
//             <SelectDropdown options={employees} value={selectedEmployee} onChange={setSelectedEmployee} placeholder="All Employees" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
//           </div>

//           <button onClick={resetAllFilters} className="flex items-center gap-1.5 px-4 py-2 border rounded-lg text-xs font-semibold h-9 mt-5 border-slate-200 hover:bg-slate-50 transition-colors">
//             <Filter className="h-4 w-4" /> Reset Filters
//           </button>
//         </div>

//         {/* Global string search bar */}
//         <div className="relative pt-1 text-left">
//           <Search className="w-4 h-4 text-slate-400 absolute left-3 top-3.5" />
//           <input 
//             type="text" 
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             placeholder="Search employees dynamically by name or id..."
//             className="w-full border border-slate-200 rounded-lg pl-9 pr-4 py-1.5 text-xs outline-none focus:ring-1 focus:ring-red-200 h-9"
//           />
//         </div>
//       </div>

//       {/* MODERN TABLE */}
//       <div className="">
//         <div className="pb-4 flex justify-between items-center">
//           <span className="font-bold text-slate-800 text-lg">Employee Appraisals Summary ({employeeGroupedReviews.length})</span>
//         </div>

//         <ModernTable 
//           columns={columns}
//           data={paginatedGroupedReviews}
//           actions={tableActions}
//           actionType="dropdown"
//           selectable={false}
//           stickyColumns={1}
//           pagination={{
//             totalItems: employeeGroupedReviews.length,
//             itemsPerPage: itemsPerPage,
//             currentPage: currentPage,
//             onPageChange: setCurrentPage
//           }}
//         />
//       </div>


//     </div>

//       {/* INTERMEDIATE SUB-LIST MODAL */}
//       {selectedEmployeeAppraisals && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[70] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-3xl rounded-2xl shadow-2xl border flex flex-col max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200 text-left">
            
//             {/* Modal Header */}
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="text-left">
//                 <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
//                   Appraisal Sheets - {selectedEmployeeAppraisals.employee?.firstName} {selectedEmployeeAppraisals.employee?.lastName} (FY {selectedEmployeeAppraisals.year})
//                 </h3>
//                 <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">
//                   Showing initiated cycles for this specific financial year
//                 </p>
//               </div>
//               <button 
//                 onClick={() => setSelectedEmployeeAppraisals(null)}
//                 className="p-1 sm:p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             {/* Modal Body: Nested Reviews list */}
//             <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/50">
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 {selectedEmployeeAppraisals.appraisals?.map((review) => {
//                   const isCompleted = review.status === "COMPLETED";
//                   const currentStageName = review.stages?.[review.currentStageIndex]?.stageName || "In Progress";
                  
//                   const latestEval = review.overallEvaluations?.[review.overallEvaluations.length - 1];
//                   const hasScore = latestEval && latestEval.overallScore !== undefined;
//                   const isOutOfFive = latestEval?.overallScore <= 5;
//                   const activeWeightageSum = review.kras?.reduce((sum, k) => sum + Number(k.weightage || 0), 0) || 100;

//                   const activeStage = review.stages?.[review.currentStageIndex];
//                   const activeEvaluatorName = activeStage?.evaluatorId?.firstName 
//                     ? `${activeStage.evaluatorId.firstName} ${activeStage.evaluatorId.lastName || ""}`.trim() 
//                     : "N/A";

//                   return (
//                     <div 
//                       key={review._id} 
//                       className="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between space-y-4 hover:border-primary/40 transition-colors"
//                     >
//                       <div className="space-y-2.5 text-left">
//                         <div className="flex justify-between items-start gap-2">
//                           <div>
//                             <span className="text-[10px] bg-slate-100 text-slate-700 border border-slate-200 font-bold px-2 py-0.5 rounded uppercase">
//                               FY {review.year}
//                             </span>
//                             <h4 className="font-bold text-gray-900 text-sm sm:text-base leading-tight mt-1">
//                               {review.period} Appraisal
//                             </h4>
//                           </div>
                          
//                           <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
//                             isCompleted 
//                               ? "bg-green-50 text-green-700 border-green-200" 
//                               : "bg-blue-50 text-blue-700 border-blue-200"
//                           }`}>
//                             {review.status}
//                           </span>
//                         </div>

//                         <div className="space-y-1.5 text-xs border-t pt-2 text-slate-500">
//                           <p>
//                             Active Step: <strong className="text-slate-800">{isCompleted ? "Completed" : currentStageName}</strong>
//                           </p>
//                           {!isCompleted && (
//                             <p className="text-[11px] text-slate-400 font-medium">
//                               Current Evaluator: <strong className="text-slate-600">{activeEvaluatorName}</strong>
//                             </p>
//                           )}
//                           {hasScore && (
//                             <div className="flex items-center gap-1.5 pt-1">
//                               <span className="text-slate-500 font-semibold">Latest Score:</span>
//                               <span className="flex items-center gap-0.5 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-2 py-0.5 rounded text-[11px]">
//                                 <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
//                                 {latestEval.overallScore?.toFixed(2)} {isOutOfFive ? "/ 5.00" : `/ ${activeWeightageSum}`}
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       </div>

//                       <div className="pt-3 border-t flex justify-end gap-2 shrink-0">
//                         {!isCompleted && !isSelfAssessmentStage(review) && (
//                           <button
//                             onClick={() => handleSkipStage(review)}
//                             disabled={skippingId === review._id}
//                             className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-[10px] font-bold uppercase transition-colors"
//                           >
//                             {skippingId === review._id ? "Bypassing..." : "Skip Stage"}
//                           </button>
//                         )}
//                         <button
//                           onClick={() => handleOpenDetailsModal(review)}
//                           className="px-3 py-1.5 bg-slate-50 hover:bg-slate-100 text-slate-700 border rounded-lg text-[10px] font-bold uppercase transition-colors flex items-center gap-1"
//                         >
//                           <span>Open Sheet</span>
//                           <ArrowRight className="w-3 h-3" />
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="p-4 border-t bg-slate-50 flex justify-end shrink-0">
//               <button
//                 onClick={() => setSelectedEmployeeAppraisals(null)}
//                 className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
//               >
//                 Close View
//               </button>
//             </div>

//           </div>
//         </div>
//       )}

//       {/* COMPREHENSIVE APPRAISAL REVIEW DETAILS MODAL WITH STAGE MATRIX */}
//       {selectedReview && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[75] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl border flex flex-col max-h-[92vh] sm:max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            
//             {/* Modal Header */}
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0 border border-emerald-100">
//                   <Award className="w-5 h-5" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
//                     {selectedReview.userId?.firstName} {selectedReview.userId?.lastName} - Appraisal Review
//                   </h3>
//                   <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">
//                     {selectedReview.period} • FY {selectedReview.year} Appraisal Details
//                   </p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setSelectedReview(null)}
//                 className="p-1 sm:p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="p-4 sm:p-6 space-y-6 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/50 font-medium">
              
//               {/* Employee Job Meta Details */}
//               <div className="bg-white border rounded-xl p-4 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-4 text-xs text-left">
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Employee ID</span>
//                   <span className="font-bold text-gray-800">{selectedReview.userId?.userId || "N/A"}</span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Department</span>
//                   <span className="font-bold text-gray-800">{selectedReview.userId?.departmentId?.name || "N/A"}</span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Designation</span>
//                   <span className="font-bold text-gray-800">{selectedReview.userId?.designationId?.title || "N/A"}</span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Reporting Manager</span>
//                   <span className="font-bold text-gray-800">
//                     {selectedReview.userId?.reportingManagerId 
//                       ? `${selectedReview.userId.reportingManagerId.firstName} ${selectedReview.userId.reportingManagerId.lastName}`
//                       : "N/A"}
//                   </span>
//                 </div>
//               </div>

//               {/* STAGES & OVERALL EVALUATION MATRIX */}
//               {selectedReview.overallEvaluations && selectedReview.overallEvaluations.length > 0 && (
//                 <div className="bg-white border rounded-xl p-4 shadow-sm space-y-4">
//                   <div className="flex justify-between items-center border-b pb-2">
//                     <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block text-left">Stage-wise Overall Evaluations</span>
//                   </div>

//                   {/* Stage Tabs */}
//                   <div className="flex flex-wrap gap-2 border-b pb-2">
//                     {selectedReview.overallEvaluations.map((evalItem) => {
//                       const isActive = activeStageTab === evalItem.stageKey;
//                       const stageObj = selectedReview.stages?.find(s => s.stageKey === evalItem.stageKey);
//                       return (
//                         <button
//                           key={evalItem.stageKey}
//                           type="button"
//                           onClick={() => setActiveStageTab(evalItem.stageKey)}
//                           className={`px-3 py-1.5 text-xs font-bold rounded-lg transition-colors border ${
//                             isActive 
//                               ? "bg-red-50 text-red-600 border-red-200" 
//                               : "bg-slate-50 hover:bg-slate-100 text-slate-600 border-slate-200"
//                           }`}
//                         >
//                           {stageObj?.stageName || evalItem.stageKey.replace("_", " ")}
//                         </button>
//                       );
//                     })}
//                   </div>

//                   {/* Selected Stage Tab Content */}
//                   {selectedReview.overallEvaluations.map((evalItem) => {
//                     if (activeStageTab !== evalItem.stageKey) return null;
//                     const isOutOfFive = evalItem.overallScore <= 5;
                    
//                     return (
//                       <div key={evalItem.stageKey} className="space-y-4 animate-in fade-in duration-200 text-xs text-left">
//                         <div className="flex items-center gap-3">
//                           <span className="font-medium text-slate-500">Overall Score:</span>
//                           <span className="flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-3 py-1 rounded-lg text-sm">
//                             <Star className="w-4 h-4 fill-amber-500 text-amber-500" />
//                             {evalItem.overallScore?.toFixed(2)} {isOutOfFive ? "/ 5.00" : `/ ${getSelectedReviewActiveWeightageSum.toFixed(2)}`}
//                           </span>
//                         </div>

//                         {/* Feedbacks */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                           <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm">
//                             <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Overall Reflection feedback</span>
//                             <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.overallFeedback || "No feedback comments logged."}"</p>
//                           </div>
                          
//                           {evalItem.nextYearGoalsFeedback && (
//                             <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm">
//                               <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Next Cycle learning focus / goals</span>
//                               <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.nextYearGoalsFeedback}"</p>
//                             </div>
//                           )}
                          
//                           {evalItem.additionalFeedback && (
//                             <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm sm:col-span-2">
//                               <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Remarks / Support requests</span>
//                               <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.additionalFeedback}"</p>
//                             </div>
//                           )}
//                         </div>

//                         {/* Attachments */}
//                         {evalItem.attachments && evalItem.attachments.length > 0 && (
//                           <div className="space-y-2">
//                             <span className="block font-bold text-slate-500">Attachments</span>
//                             <div className="flex flex-wrap gap-2">
//                               {evalItem.attachments.map((file, fIdx) => (
//                                 <a 
//                                   key={fIdx}
//                                   href={file.url}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   className="inline-flex items-center gap-1.5 bg-white border hover:bg-slate-50 text-red-600 px-3 py-1.5 rounded-lg font-bold shadow-sm transition-colors"
//                                 >
//                                   <Download className="w-3.5 h-3.5" />
//                                   <span>{file.name}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}

//               {/* INDIVIDUAL KRA RATING BREAKDOWN */}
//               <div className="space-y-3">
//                 <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block text-left">Key Result Areas (KRAs) Assessment Details</span>
                
//                 {selectedReview.kras?.map((kra, kIdx) => (
//                   <div key={kIdx} className="bg-white border rounded-xl p-4 shadow-sm space-y-4 text-left">
//                     <div className="flex justify-between items-start gap-4 pb-3 border-b border-slate-100">
//                       <div>
//                         <h4 className="font-bold text-gray-900 text-sm leading-tight">{kra.name}</h4>
//                         <p className="text-xs text-gray-500 mt-1">{kra.description || "No description provided."}</p>
//                       </div>
//                       <span className="bg-red-50 text-red-600 border border-red-100 text-[10px] font-bold px-2.5 py-0.5 rounded-lg shrink-0">
//                         Weightage: {kra.weightage}%
//                       </span>
//                     </div>

//                     {/* Integrated unified Target Value Display next to Legacy fields */}
//                     {/* ✅ Upgraded to sm:grid-cols-3 layout to cleanly render Goal/Metric Direction */}
//                     <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 text-[11px] text-gray-500 border-b border-dashed border-gray-100 bg-slate-50/20 p-2.5 rounded-lg">
//                       <div>
//                         <span className="text-[9px] text-gray-400 font-bold uppercase block">Review Frequency</span>
//                         <span className="font-semibold text-gray-700">{formatCycleDisplay(kra.reviewCycle)}</span>
//                       </div>
//                       <div>
//                         <span className="text-[9px] text-primary font-bold uppercase block">Target</span>
//                         <span className="font-bold text-gray-950">{kra.targetValue || kra.monthlyTarget || kra.yearlyTarget || "N/A"}</span>
//                       </div>
//                       {/* ✅ Added Goal Direction display */}
//                       <div>
//                         <span className="text-[9px] text-gray-400 font-bold uppercase block">Goal Direction</span>
//                         <span className="font-semibold text-gray-700">
//                           {kra.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Actual value and achievement percentage tracker inside Modal view */}
//                     {kra.actualValue && (
//                       <div className="bg-slate-50 border border-slate-100 rounded-lg p-3 text-xs space-y-1.5">
//                         <span className="block font-bold text-slate-500">Actual Achievement Tracker</span>
//                         <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-[11px]">
//                           <div>
//                             <span className="text-[9px] text-gray-400 font-bold block uppercase">Actual Value</span>
//                             <span className="font-extrabold text-emerald-600">{kra.actualValue}</span>
//                           </div>
//                           {kra.achievementPercentage !== undefined && kra.achievementPercentage !== null && (
//                             <>
//                               <div>
//                                 <span className="text-[9px] text-gray-400 font-bold block uppercase">Achievement %</span>
//                                 <div className="flex flex-wrap items-center gap-1.5 mt-0.5">
//                                   <span className="font-extrabold text-primary">{kra.achievementPercentage}%</span>
//                                   <span className={`text-[9px] font-bold px-1.5 py-0.2 rounded border uppercase tracking-wider ${getRatingBadgeClass(getAchievementRating(kra.achievementPercentage))}`}>
//                                     {getAchievementRating(kra.achievementPercentage)}
//                                   </span>
//                                 </div>
//                               </div>
//                               <div>
//                                 <span className="text-[9px] text-gray-400 font-bold block uppercase">Earned Score Contribution</span>
//                                 <span className="font-extrabold text-slate-700">{kra.weightedScore?.toFixed(2)} / {kra.weightage}.00</span>
//                               </div>
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {/* Stage-wise Ratings and Feedbacks Matrix */}
//                     <div className="space-y-3 text-xs">
//                       {kra.evaluations && kra.evaluations.length > 0 ? (
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//                           {kra.evaluations.map((evalItem, eIdx) => {
//                             const weightedContribution = (Number(evalItem.rating) / 5) * Number(kra.weightage);
//                             const evaluatorName = getEvaluatorName(evalItem.stageKey, evalItem.evaluatorId);

//                             return (
//                               <div key={eIdx} className="bg-slate-50/60 border rounded-lg p-3 space-y-2 flex flex-col justify-between">
//                                 <div className="space-y-1">
//                                   <span className="block font-bold text-[10px] uppercase tracking-wider text-slate-400">
//                                     {evalItem.stageName || evalItem.stageKey}
//                                   </span>
//                                   <p className="text-slate-600 leading-relaxed italic">
//                                     "{evalItem.feedback || "No feedback provided."}"
//                                   </p>
//                                 </div>
//                                 <div className="pt-2 border-t flex flex-col gap-1">
//                                   <div className="flex justify-between items-center text-[10px] text-slate-400 font-semibold">
//                                     <span>Weighted Score:</span>
//                                     <span className="font-bold text-slate-600">
//                                       ({evalItem.rating} / 5) × {kra.weightage}% = {weightedContribution.toFixed(2)}
//                                     </span>
//                                   </div>
//                                   <div className="flex justify-between items-center">
//                                     <span className="text-[10px] font-semibold text-slate-400">Rating:</span>
//                                     <span className="flex items-center gap-0.5 font-bold text-amber-600 bg-amber-50 px-2 py-0.5 rounded border border-amber-100">
//                                       {evalItem.rating} <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
//                                     </span>
//                                   </div>
//                                 </div>
                                
//                                 <div className="flex justify-between items-center text-[9px] text-slate-400 border-t border-dashed pt-1.5 mt-1 font-semibold">
//                                   <span>By: <strong>{evaluatorName}</strong></span>
//                                   {evalItem.submittedAt && (
//                                     <span>On: {new Date(evalItem.submittedAt).toLocaleDateString()}</span>
//                                   )}
//                                 </div>
//                               </div>
//                             );
//                           })}
//                         </div>
//                       ) : (
//                         <p className="text-slate-400 text-center italic py-2">No individual evaluations found for this KRA.</p>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//             </div>

//             {/* Modal Footer */}
//             <div className="p-4 border-t bg-slate-50 flex justify-end gap-3 shrink-0">
//               {selectedReview.status !== "COMPLETED" && 
//                !isSelfAssessmentStage(selectedReview) && (
//                 <button
//                   onClick={() => handleSkipStage(selectedReview)}
//                   disabled={skippingId === selectedReview._id}
//                   className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold uppercase transition-colors"
//                 >
//                   {skippingId === selectedReview._id ? "Bypassing..." : "Skip Active Stage"}
//                 </button>
//               )}
              
//               <button
//                 onClick={() => setSelectedReview(null)}
//                 className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
//               >
//                 Close View
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </>
//   );
// };

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import { 
  Users, CheckCircle2, Clock, Eye, 
  Award, X, Search, Star, Download, Filter, ArrowRight, Edit3, ChevronDown
} from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import ModernTable from "../ui/ModernTable";

// Helper to format system DB cycle keys to user-friendly labels
const formatCycleDisplay = (cycle) => {
  const mapping = {
    "1_WEEK": "Weekly",
    "2_WEEKS": "Bi-weekly",
    "1_MONTH": "Monthly",
    "2_MONTHS": "Bi-monthly",
    "3_MONTHS": "Quarterly",
    "6_MONTHS": "Half-Yearly",
    "12_MONTHS": "Annual"
  };
  return mapping[cycle] || cycle;
};

// Helper function to resolve KRA achievement rating
const getAchievementRating = (percentage) => {
  if (percentage === null || percentage === undefined || isNaN(percentage)) return "N/A";
  if (percentage >= 110) return "Outstanding";
  if (percentage >= 100) return "Exceeds Expectations";
  if (percentage >= 90) return "Meets Expectations";
  if (percentage >= 75) return "Needs Improvement";
  return "Unsatisfactory";
};

// Helper function to return beautiful styling badge classes
const getRatingBadgeClass = (rating) => {
  switch (rating) {
    case "Outstanding": return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "Exceeds Expectations": return "bg-teal-50 text-teal-700 border-teal-200";
    case "Meets Expectations": return "bg-blue-50 text-blue-700 border-blue-200";
    case "Needs Improvement": return "bg-amber-50 text-amber-700 border-amber-200";
    case "Unsatisfactory": return "bg-red-50 text-red-700 border-red-200";
    default: return "bg-gray-50 text-gray-700 border-gray-200";
  }
};

export default function KraReviewsList() {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [selectedEmployeeAppraisals, setSelectedEmployeeAppraisals] = useState(null); 
  const [activeStageTab, setActiveStageTab] = useState("");
  const [skippingId, setSkippingId] = useState(null); 

  // --- NEW: Edit Review Modal States ---
  const [showEditReviewModal, setShowEditReviewModal] = useState(false);
  const [updatingReview, setUpdatingReview] = useState(false);
  const [editReviewForm, setEditReviewForm] = useState({
    id: "",
    employeeName: "",
    period: "",
    startDate: "",
    endDate: "",
    kras: []
  });

  // Filters Master lists state
  const [departments, setDepartments] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);

  // Selected Filter States
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");

  // Search & Basic Filter States
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedYear, setSelectedYear] = useState(""); 
  const [selectedStatus, setSelectedStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Fetch active structural dependencies for dropdown filters on mount
  const loadReviewsAndFilters = useCallback(async () => {
    setLoading(true);
    try {
      const url = SummaryApi.listReviewsKra?.url || "/api/hr/kra/reviews/view-all";
      const [reviewsRes, deptRes, divRes, empRes] = await Promise.all([
        api.get(url),
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDivisions.url),
        api.get(SummaryApi.getAllEmployees?.url || "/api/hr/employees/active-list") 
      ]);

      if (reviewsRes.data.success) setReviews(reviewsRes.data.data || []);
      if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (empRes.data.success) setEmployees(empRes.data.data.map(e => ({ label: `${e.firstName} ${e.lastName}`, value: e._id })));
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load active appraisal sheets.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadReviewsAndFilters();
  }, [loadReviewsAndFilters]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, selectedPeriod, selectedYear, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

  const periods = useMemo(() => {
    const list = reviews.map(r => r.period).filter(Boolean);
    return [...new Set(list)].map(item => ({ label: item, value: item }));
  }, [reviews]);

  const years = useMemo(() => {
    const list = reviews.map(r => r.year).filter(Boolean);
    return [...new Set(list)].map(item => ({ label: `FY ${item}`, value: item }));
  }, [reviews]);

  const stats = useMemo(() => {
    const totalCount = reviews.length;
    const completedCount = reviews.filter(r => r.status === "COMPLETED").length;
    const pendingCount = totalCount - completedCount;

    const completedReviews = reviews.filter(r => r.status === "COMPLETED");
    let totalScoreSum = 0;
    completedReviews.forEach(r => {
      const latestEval = r.overallEvaluations?.[r.overallEvaluations.length - 1];
      if (latestEval && latestEval.overallScore) {
        totalScoreSum += latestEval.overallScore;
      }
    });
    const avgScore = completedReviews.length > 0 ? (totalScoreSum / completedReviews.length).toFixed(2) : "0.00";

    return { totalCount, completedCount, pendingCount, avgScore };
  }, [reviews]);

  const filteredReviews = useMemo(() => {
    return reviews.filter(r => {
      const user = r.userId || {};
      const fullName = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      
      const matchesSearch = fullName.includes(searchQuery.toLowerCase()) || 
                            (user.userId && user.userId.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesPeriod = !selectedPeriod || r.period === selectedPeriod;
      const matchesYear = !selectedYear || selectedYear === "" || Number(r.year) === Number(selectedYear);
      const matchesStatus = !selectedStatus || r.status === selectedStatus;

      const uDeptId = user.departmentId?._id || user.departmentId;
      const uDivId = user.divisionId?._id || user.divisionId;

      const matchesDepartment = !selectedDepartment || uDeptId === selectedDepartment;
      const matchesDivision = !selectedDivision || uDivId === selectedDivision;
      const matchesEmployee = !selectedEmployee || user._id === selectedEmployee;

      return matchesSearch && matchesPeriod && matchesYear && matchesStatus && matchesDepartment && matchesDivision && matchesEmployee;
    });
  }, [reviews, searchQuery, selectedPeriod, selectedYear, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

  const employeeGroupedReviews = useMemo(() => {
    const map = {};
    filteredReviews.forEach(review => {
      const empId = review.userId?._id;
      if (!empId) return;

      const groupKey = `${empId}_${review.year}`;

      if (!map[groupKey]) {
        map[groupKey] = {
          employee: review.userId,
          year: review.year, 
          appraisals: [],
          completedCount: 0
        };
      }
      map[groupKey].appraisals.push(review);
      if (review.status === "COMPLETED") {
        map[groupKey].completedCount += 1;
      }
    });

    return Object.values(map).map(item => {
      let scoreSum = 0;
      let scoreCount = 0;
      item.appraisals.forEach(r => {
        const latestEval = r.overallEvaluations?.[r.overallEvaluations.length - 1];
        if (latestEval && latestEval.overallScore) {
          scoreSum += latestEval.overallScore;
          scoreCount += 1;
        }
      });
      const avgScore = scoreCount > 0 ? (scoreSum / scoreCount).toFixed(2) : "-";
      return {
        ...item,
        avgScore
      };
    });
  }, [filteredReviews]);

  const paginatedGroupedReviews = useMemo(() => {
    const startIdx = (currentPage - 1) * itemsPerPage;
    return employeeGroupedReviews.slice(startIdx, startIdx + itemsPerPage);
  }, [employeeGroupedReviews, currentPage]);

  const handleOpenDetailsModal = useCallback((review) => {
    setSelectedReview(review);
    if (review.overallEvaluations && review.overallEvaluations.length > 0) {
      setActiveStageTab(review.overallEvaluations[0].stageKey);
    } else {
      setActiveStageTab("");
    }
  }, []);

  const isSelfAssessmentStage = useCallback((row) => {
    const currentStage = row?.stages?.[row.currentStageIndex];
    if (!currentStage) return false;
    const stageKey = String(currentStage.stageKey).toLowerCase();
    const isSelfKey = stageKey.includes("self") || stageKey.includes("employee");
    const evaluatorId = currentStage.evaluatorId?._id || currentStage.evaluatorId;
    const userId = row.userId?._id || row.userId;
    const isSelfEvaluator = evaluatorId && userId && evaluatorId.toString() === userId.toString();
    return isSelfKey || isSelfEvaluator;
  }, []);

  const getEvaluatorName = (stageKey, evaluatorId) => {
    if (!selectedReview?.stages) return "Evaluator";
    const stageObj = selectedReview.stages.find(s => s.stageKey === stageKey);
    if (stageObj?.evaluatorId) {
      const evalObj = stageObj.evaluatorId;
      if (evalObj.firstName) {
        return `${evalObj.firstName} ${evalObj.lastName || ""}`.trim();
      }
    }
    if (evaluatorId && typeof evaluatorId === 'object' && evaluatorId.firstName) {
      return `${evaluatorId.firstName} ${evaluatorId.lastName || ""}`.trim();
    }
    return "Evaluator";
  };

  const handleSkipStage = useCallback(async (review) => {
    if (review.status === "COMPLETED") {
      return toast.warning("This review sheet is already completed and locked.");
    }
    if (isSelfAssessmentStage(review)) {
      return toast.error("The Self Assessment stage is mandatory and cannot be skipped.");
    }
    const currentStageName = review.stages[review.currentStageIndex]?.stageName || "Active Stage";
    if (!window.confirm(`Are you sure you want to bypass/skip the current evaluation stage (${currentStageName}) for this employee?`)) {
      return;
    }
    setSkippingId(review._id);
    try {
      const url = SummaryApi.skipKraReviewStage?.url || "/api/hr/kra/reviews/skip";
      const res = await api.post(url, { reviewId: review._id });
      if (res.data.success) {
        toast.success("Active review stage bypassed successfully.");
        const updatedReview = res.data.data;
        setReviews(prev => prev.map(r => r._id === review._id ? updatedReview : r));
        if (selectedEmployeeAppraisals) {
          setSelectedEmployeeAppraisals(prev => {
            const updatedAppraisals = prev.appraisals.map(r => r._id === review._id ? updatedReview : r);
            return { ...prev, appraisals: updatedAppraisals };
          });
        }
        if (selectedReview && selectedReview._id === review._id) {
          setSelectedReview(updatedReview);
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to bypass/skip evaluation stage.");
    } finally {
      setSkippingId(null);
    }
  }, [selectedReview, selectedEmployeeAppraisals, isSelfAssessmentStage]); 

  // --- NEW: EDIT REVIEW LOGIC ---
  const handleOpenEditReviewModal = (review) => {
    setEditReviewForm({
      id: review._id,
      employeeName: `${review.userId?.firstName || ""} ${review.userId?.lastName || ""}`.trim(),
      period: review.period,
      startDate: review.startDate ? review.startDate.substring(0, 10) : "",
      endDate: review.endDate ? review.endDate.substring(0, 10) : "",
      kras: review.kras?.map(k => ({
        kraId: k.kraId?._id || k.kraId,
        name: k.name || "",
        category: k.category || "Technical",
        weightage: k.weightage || 0,
        targetValue: k.targetValue || k.monthlyTarget || k.yearlyTarget || "",
        metricType: k.metricType || "HIGHER_IS_BETTER"
      })) || []
    });
    setShowEditReviewModal(true);
  };

  const handleEditReviewKraChange = (index, key, val) => {
    const updated = editReviewForm.kras.map((k, idx) => 
      idx === index ? { ...k, [key]: val } : k
    );
    setEditReviewForm(p => ({ ...p, kras: updated }));
  };

  const handleAutoSplitEditReviewWeights = () => {
    const totalKras = editReviewForm.kras.length;
    if (totalKras === 0) return;
    const baseWeight = Math.floor(100 / totalKras);
    const remainder = 100 % totalKras;
    const updated = editReviewForm.kras.map((k, idx) => ({
      ...k, 
      weightage: idx < remainder ? baseWeight + 1 : baseWeight
    }));
    setEditReviewForm(p => ({ ...p, kras: updated }));
    toast.info("Weights distributed equally!");
  };

  const totalEditReviewWeightSum = useMemo(() => {
    return editReviewForm.kras.reduce((sum, k) => sum + Number(k.weightage || 0), 0);
  }, [editReviewForm.kras]);

  const handleEditReviewSubmit = async (e) => {
    e.preventDefault();
    if (totalEditReviewWeightSum !== 100) {
      return toast.error(`Total weightage must equal 100%. Current: ${totalEditReviewWeightSum}%`);
    }
    setUpdatingReview(true);
    try {
      const payload = {
        startDate: editReviewForm.startDate,
        endDate: editReviewForm.endDate,
        kras: editReviewForm.kras.map(k => ({
          kraId: k.kraId,
          weightage: k.weightage,
          targetValue: k.targetValue,
          metricType: k.metricType
        }))
      };
      
      const endpoint = SummaryApi.updateInitiatedReview?.url 
        ? SummaryApi.updateInitiatedReview.url(editReviewForm.id) 
        : `/api/hr/kra/reviews/${editReviewForm.id}`;
        
      const res = await api.put(endpoint, payload);
      
      if (res.data.success) {
        toast.success("Review sheet updated successfully.");
        setShowEditReviewModal(false);
        const updatedReview = res.data.data;
        
        setReviews(prev => prev.map(r => r._id === updatedReview._id ? updatedReview : r));
        
        if (selectedEmployeeAppraisals) {
          setSelectedEmployeeAppraisals(prev => {
            const updatedAppraisals = prev.appraisals.map(r => r._id === updatedReview._id ? updatedReview : r);
            return { ...prev, appraisals: updatedAppraisals };
          });
        }
        if (selectedReview && selectedReview._id === updatedReview._id) {
          setSelectedReview(updatedReview);
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update review sheet.");
    } finally {
      setUpdatingReview(false);
    }
  };
  // --------------------------------

  const getSelectedReviewActiveWeightageSum = useMemo(() => {
    if (!selectedReview || !selectedReview.kras) return 100;
    return selectedReview.kras.reduce((sum, k) => sum + Number(k.weightage || 0), 0);
  }, [selectedReview]);

  const columns = useMemo(() => [
    {
      key: "employee",
      label: "Employee Profile",
      render: (row) => {
        const user = row.employee || {};
        return (
          <div className="flex items-center gap-3">
            {user.profilePicture ? (
              <img src={user.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 text-[10px] font-bold shrink-0">
                {user.firstName?.[0] || ""}{user.lastName?.[0] || ""}
              </div>
            )}
            <div>
              <p className="font-bold text-slate-900 whitespace-nowrap text-left">{user.firstName} {user.lastName}</p>
              <p className="text-[10px] text-slate-400 font-medium whitespace-nowrap text-left">{user.email}</p>
            </div>
          </div>
        );
      }
    },
    {
      key: "employeeId",
      label: "Employee ID",
      render: (row) => {
        const user = row.employee || {};
        return <span className="font-semibold text-slate-500 whitespace-nowrap">{user.userId || "EMP-N/A"}</span>;
      }
    },
    {
      key: "year",
      label: "Appraisal Year",
      render: (row) => (
        <span className="font-bold text-slate-700 whitespace-nowrap bg-slate-50 border px-2.5 py-1 rounded-lg">
          FY {row.year}
        </span>
      )
    },
    {
      key: "department",
      label: "Department & Title",
      render: (row) => {
        const user = row.employee || {};
        return (
          <div className="text-left whitespace-nowrap">
            <p className="text-xs font-semibold text-slate-700 leading-tight">{user.departmentId?.name || "N/A"}</p>
            <p className="text-[10px] text-slate-400 font-medium mt-0.5">{user.designationId?.title || "N/A"}</p>
          </div>
        );
      }
    },
    {
      key: "appraisalCount",
      label: "Appraisals Group Info",
      render: (row) => (
        <span className="text-slate-600 font-bold whitespace-nowrap">
          {row.completedCount} / {row.appraisals.length} Completed
        </span>
      )
    },
    {
      key: "avgScore",
      label: "Average Score",
      headerAlign: "center",
      render: (row) => {
        if (row.avgScore === "-") {
          return <div className="text-center text-slate-400 font-semibold">-</div>;
        }
        const isOutOfFive = parseFloat(row.avgScore) <= 5;
        return (
          <div className="flex justify-center">
            <span className="flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-2 py-0.5 rounded-lg text-xs">
              <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
              {row.avgScore} {isOutOfFive ? "/ 5" : ""}
            </span>
          </div>
        );
      }
    }
  ], []);

  const tableActions = useMemo(() => [
    {
      label: "Manage Appraisals",
      icon: <Eye className="w-4 h-4 text-slate-500" />,
      onClick: (row) => {
        setSelectedEmployeeAppraisals(row); 
      }
    }
  ], []);

  const resetAllFilters = () => {
    setSelectedDepartment("");
    setSelectedDivision("");
    setSelectedEmployee("");
    setSelectedPeriod("");
    setSelectedYear("");
    setSelectedStatus("");
    setSearchQuery("");
  };

  if (loading) return <PageLoader />;

  return (
    <>
    <div className="space-y-4 animate-in fade-in duration-300">
      
      {/* HEADER CONTROLS */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="text-left">
          <h1 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight">KRA Appraisal Reviews</h1>
          <p className="text-xs text-slate-400 mt-1">Monitor ongoing appraisals, scores, and evaluation feedback across stages.</p>
        </div>
      </div>

      {/* STATS ROW */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-50 border border-blue-100 rounded-full flex items-center justify-center text-blue-600 shrink-0">
            <Users className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Total Appraisals</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.totalCount}</p>
            <span className="text-[10px] text-slate-400 font-semibold">Initiated Cycles</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-green-50 border border-green-100 rounded-full flex items-center justify-center text-green-600 shrink-0">
            <CheckCircle2 className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Completed</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.completedCount}</p>
            <span className="text-[10px] text-green-600 font-semibold">Fully Approved & Closed</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-amber-50 border border-amber-100 rounded-full flex items-center justify-center text-amber-600 shrink-0">
            <Clock className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">In Progress</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.pendingCount}</p>
            <span className="text-[10px] text-amber-600 font-semibold">Awaiting Assessments</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-pink-50 border border-pink-100 rounded-full flex items-center justify-center text-pink-500 shrink-0">
            <Star className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Average Score</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.avgScore}</p>
            <span className="text-[10px] text-slate-400 font-semibold">Weighted Evaluations Tracker</span>
          </div>
        </div>
      </div>

      {/* ADVANCED FILTER BOARD */}
      <div className="bg-white border rounded-xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.02)] space-y-4">
        <div className="flex flex-wrap items-center gap-4">
          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Year</span>
            <SelectDropdown options={years} value={selectedYear} onChange={setSelectedYear} placeholder="All Years" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Period</span>
            <SelectDropdown options={periods} value={selectedPeriod} onChange={setSelectedPeriod} placeholder="All Periods" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Status</span>
            <SelectDropdown options={[{ label: "Completed", value: "COMPLETED" }, { label: "In Progress", value: "UNDER_REVIEW" }, { label: "Draft", value: "DRAFT" }]} value={selectedStatus} onChange={setSelectedStatus} placeholder="All Status" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Division</span>
            <SelectDropdown options={divisions} value={selectedDivision} onChange={setSelectedDivision} placeholder="All Divisions" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Department</span>
            <SelectDropdown options={departments} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Employee Selection</span>
            <SelectDropdown options={employees} value={selectedEmployee} onChange={setSelectedEmployee} placeholder="All Employees" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200 focus:border-red-400" searchable={true} />
          </div>

          <button onClick={resetAllFilters} className="flex items-center gap-1.5 px-4 py-2 border rounded-lg text-xs font-semibold h-9 mt-5 border-slate-200 hover:bg-slate-50 transition-colors">
            <Filter className="h-4 w-4" /> Reset Filters
          </button>
        </div>

        {/* Global string search bar */}
        <div className="relative pt-1 text-left">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-3.5" />
          <input 
            type="text" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search employees dynamically by name or id..."
            className="w-full border border-slate-200 rounded-lg pl-9 pr-4 py-1.5 text-xs outline-none focus:ring-1 focus:ring-red-200 h-9"
          />
        </div>
      </div>

      {/* MODERN TABLE */}
      <div className="">
        <div className="pb-4 flex justify-between items-center">
          <span className="font-bold text-slate-800 text-lg">Employee Appraisals Summary ({employeeGroupedReviews.length})</span>
        </div>

        <ModernTable 
          columns={columns}
          data={paginatedGroupedReviews}
          actions={tableActions}
          actionType="dropdown"
          selectable={false}
          stickyColumns={1}
          pagination={{
            totalItems: employeeGroupedReviews.length,
            itemsPerPage: itemsPerPage,
            currentPage: currentPage,
            onPageChange: setCurrentPage
          }}
        />
      </div>

    </div>

      {/* INTERMEDIATE SUB-LIST MODAL */}
      {selectedEmployeeAppraisals && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[70] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-3xl rounded-2xl shadow-2xl border flex flex-col max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200 text-left">
            
            {/* Modal Header */}
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="text-left">
                <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
                  Appraisal Sheets - {selectedEmployeeAppraisals.employee?.firstName} {selectedEmployeeAppraisals.employee?.lastName} (FY {selectedEmployeeAppraisals.year})
                </h3>
                <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">
                  Showing initiated cycles for this specific financial year
                </p>
              </div>
              <button 
                onClick={() => setSelectedEmployeeAppraisals(null)}
                className="p-1 sm:p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Modal Body: Nested Reviews list */}
            <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/50">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {selectedEmployeeAppraisals.appraisals?.map((review) => {
                  const isCompleted = review.status === "COMPLETED";
                  const currentStageName = review.stages?.[review.currentStageIndex]?.stageName || "In Progress";
                  
                  const latestEval = review.overallEvaluations?.[review.overallEvaluations.length - 1];
                  const hasScore = latestEval && latestEval.overallScore !== undefined;
                  const isOutOfFive = latestEval?.overallScore <= 5;
                  const activeWeightageSum = review.kras?.reduce((sum, k) => sum + Number(k.weightage || 0), 0) || 100;

                  const activeStage = review.stages?.[review.currentStageIndex];
                  const activeEvaluatorName = activeStage?.evaluatorId?.firstName 
                    ? `${activeStage.evaluatorId.firstName} ${activeStage.evaluatorId.lastName || ""}`.trim() 
                    : "N/A";

                  return (
                    <div 
                      key={review._id} 
                      className="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between space-y-4 hover:border-primary/40 transition-colors"
                    >
                      <div className="space-y-2.5 text-left">
                        <div className="flex justify-between items-start gap-2">
                          <div>
                            <span className="text-[10px] bg-slate-100 text-slate-700 border border-slate-200 font-bold px-2 py-0.5 rounded uppercase">
                              FY {review.year}
                            </span>
                            <h4 className="font-bold text-gray-900 text-sm sm:text-base leading-tight mt-1">
                              {review.period} Appraisal
                            </h4>
                          </div>
                          
                          <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
                            isCompleted 
                              ? "bg-green-50 text-green-700 border-green-200" 
                              : "bg-blue-50 text-blue-700 border-blue-200"
                          }`}>
                            {review.status}
                          </span>
                        </div>

                        <div className="space-y-1.5 text-xs border-t pt-2 text-slate-500">
                          <p>
                            Active Step: <strong className="text-slate-800">{isCompleted ? "Completed" : currentStageName}</strong>
                          </p>
                          {!isCompleted && (
                            <p className="text-[11px] text-slate-400 font-medium">
                              Current Evaluator: <strong className="text-slate-600">{activeEvaluatorName}</strong>
                            </p>
                          )}
                          {hasScore && (
                            <div className="flex items-center gap-1.5 pt-1">
                              <span className="text-slate-500 font-semibold">Latest Score:</span>
                              <span className="flex items-center gap-0.5 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-2 py-0.5 rounded text-[11px]">
                                <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
                                {latestEval.overallScore?.toFixed(2)} {isOutOfFive ? "/ 5.00" : `/ ${activeWeightageSum}`}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="pt-3 border-t flex justify-end gap-2 shrink-0">
                        {/* ⬇️ EDIT REVIEW BUTTON ⬇️ */}
                        {!isCompleted && (
                          <button
                            onClick={() => handleOpenEditReviewModal(review)}
                            className="px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-[10px] font-bold uppercase transition-colors flex items-center gap-1"
                          >
                            <Edit3 className="w-3 h-3" />
                            <span>Edit Sheet</span>
                          </button>
                        )}

                        {!isCompleted && !isSelfAssessmentStage(review) && (
                          <button
                            onClick={() => handleSkipStage(review)}
                            disabled={skippingId === review._id}
                            className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-[10px] font-bold uppercase transition-colors"
                          >
                            {skippingId === review._id ? "Bypassing..." : "Skip Stage"}
                          </button>
                        )}
                        <button
                          onClick={() => handleOpenDetailsModal(review)}
                          className="px-3 py-1.5 bg-slate-50 hover:bg-slate-100 text-slate-700 border rounded-lg text-[10px] font-bold uppercase transition-colors flex items-center gap-1"
                        >
                          <span>Open Sheet</span>
                          <ArrowRight className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="p-4 border-t bg-slate-50 flex justify-end shrink-0">
              <button
                onClick={() => setSelectedEmployeeAppraisals(null)}
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
              >
                Close View
              </button>
            </div>

          </div>
        </div>
      )}

      {/* COMPREHENSIVE APPRAISAL REVIEW DETAILS MODAL WITH STAGE MATRIX */}
      {selectedReview && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[75] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl border flex flex-col max-h-[92vh] sm:max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            
            {/* Modal Header */}
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0 border border-emerald-100">
                  <Award className="w-5 h-5" />
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
                    {selectedReview.userId?.firstName} {selectedReview.userId?.lastName} - Appraisal Review
                  </h3>
                  <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">
                    {selectedReview.period} • FY {selectedReview.year} Appraisal Details
                  </p>
                </div>
              </div>
              <button 
                onClick={() => setSelectedReview(null)}
                className="p-1 sm:p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-4 sm:p-6 space-y-6 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/50 font-medium">
              
              {/* Employee Job Meta Details */}
              <div className="bg-white border rounded-xl p-4 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-4 text-xs text-left">
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Employee ID</span>
                  <span className="font-bold text-gray-800">{selectedReview.userId?.userId || "N/A"}</span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Department</span>
                  <span className="font-bold text-gray-800">{selectedReview.userId?.departmentId?.name || "N/A"}</span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Designation</span>
                  <span className="font-bold text-gray-800">{selectedReview.userId?.designationId?.title || "N/A"}</span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Reporting Manager</span>
                  <span className="font-bold text-gray-800">
                    {selectedReview.userId?.reportingManagerId 
                      ? `${selectedReview.userId.reportingManagerId.firstName} ${selectedReview.userId.reportingManagerId.lastName}`
                      : "N/A"}
                  </span>
                </div>
              </div>

              {/* STAGES & OVERALL EVALUATION MATRIX */}
              {selectedReview.overallEvaluations && selectedReview.overallEvaluations.length > 0 && (
                <div className="bg-white border rounded-xl p-4 shadow-sm space-y-4">
                  <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block text-left">Stage-wise Overall Evaluations</span>
                  </div>

                  {/* Stage Tabs */}
                  <div className="flex flex-wrap gap-2 border-b pb-2">
                    {selectedReview.overallEvaluations.map((evalItem) => {
                      const isActive = activeStageTab === evalItem.stageKey;
                      const stageObj = selectedReview.stages?.find(s => s.stageKey === evalItem.stageKey);
                      return (
                        <button
                          key={evalItem.stageKey}
                          type="button"
                          onClick={() => setActiveStageTab(evalItem.stageKey)}
                          className={`px-3 py-1.5 text-xs font-bold rounded-lg transition-colors border ${
                            isActive 
                              ? "bg-red-50 text-red-600 border-red-200" 
                              : "bg-slate-50 hover:bg-slate-100 text-slate-600 border-slate-200"
                          }`}
                        >
                          {stageObj?.stageName || evalItem.stageKey.replace("_", " ")}
                        </button>
                      );
                    })}
                  </div>

                  {/* Selected Stage Tab Content */}
                  {selectedReview.overallEvaluations.map((evalItem) => {
                    if (activeStageTab !== evalItem.stageKey) return null;
                    const isOutOfFive = evalItem.overallScore <= 5;
                    
                    return (
                      <div key={evalItem.stageKey} className="space-y-4 animate-in fade-in duration-200 text-xs text-left">
                        <div className="flex items-center gap-3">
                          <span className="font-medium text-slate-500">Overall Score:</span>
                          <span className="flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-3 py-1 rounded-lg text-sm">
                            <Star className="w-4 h-4 fill-amber-500 text-amber-500" />
                            {evalItem.overallScore?.toFixed(2)} {isOutOfFive ? "/ 5.00" : `/ ${getSelectedReviewActiveWeightageSum.toFixed(2)}`}
                          </span>
                        </div>

                        {/* Feedbacks */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm">
                            <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Overall Reflection feedback</span>
                            <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.overallFeedback || "No feedback comments logged."}"</p>
                          </div>
                          
                          {evalItem.nextYearGoalsFeedback && (
                            <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm">
                              <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Next Cycle learning focus / goals</span>
                              <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.nextYearGoalsFeedback}"</p>
                            </div>
                          )}
                          
                          {evalItem.additionalFeedback && (
                            <div className="bg-slate-50 border p-3.5 rounded-xl text-xs space-y-3 shadow-sm sm:col-span-2">
                              <span className="text-[9px] text-slate-400 font-bold uppercase block border-b pb-1">Remarks / Support requests</span>
                              <p className="text-slate-700 italic font-semibold leading-relaxed mt-0.5">"{evalItem.additionalFeedback}"</p>
                            </div>
                          )}
                        </div>

                        {/* Attachments */}
                        {evalItem.attachments && evalItem.attachments.length > 0 && (
                          <div className="space-y-2">
                            <span className="block font-bold text-slate-500">Attachments</span>
                            <div className="flex flex-wrap gap-2">
                              {evalItem.attachments.map((file, fIdx) => (
                                <a 
                                  key={fIdx}
                                  href={file.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="inline-flex items-center gap-1.5 bg-white border hover:bg-slate-50 text-red-600 px-3 py-1.5 rounded-lg font-bold shadow-sm transition-colors"
                                >
                                  <Download className="w-3.5 h-3.5" />
                                  <span>{file.name}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* INDIVIDUAL KRA RATING BREAKDOWN */}
              <div className="space-y-3">
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block text-left">Key Result Areas (KRAs) Assessment Details</span>
                
                {selectedReview.kras?.map((kra, kIdx) => (
                  <div key={kIdx} className="bg-white border rounded-xl p-4 shadow-sm space-y-4 text-left">
                    <div className="flex justify-between items-start gap-4 pb-3 border-b border-slate-100">
                      <div>
                        <h4 className="font-bold text-gray-900 text-sm leading-tight">{kra.name}</h4>
                        <p className="text-xs text-gray-500 mt-1">{kra.description || "No description provided."}</p>
                      </div>
                      <span className="bg-red-50 text-red-600 border border-red-100 text-[10px] font-bold px-2.5 py-0.5 rounded-lg shrink-0">
                        Weightage: {kra.weightage}%
                      </span>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 text-[11px] text-gray-500 border-b border-dashed border-gray-100 bg-slate-50/20 p-2.5 rounded-lg">
                      <div>
                        <span className="text-[9px] text-gray-400 font-bold uppercase block">Review Frequency</span>
                        <span className="font-semibold text-gray-700">{formatCycleDisplay(kra.reviewCycle)}</span>
                      </div>
                      <div>
                        <span className="text-[9px] text-primary font-bold uppercase block">Target</span>
                        <span className="font-bold text-gray-950">{kra.targetValue || kra.monthlyTarget || kra.yearlyTarget || "N/A"}</span>
                      </div>
                      <div>
                        <span className="text-[9px] text-gray-400 font-bold uppercase block">Goal Direction</span>
                        <span className="font-semibold text-gray-700">
                          {kra.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}
                        </span>
                      </div>
                    </div>

                    {/* Actual value and achievement percentage tracker inside Modal view */}
                    {kra.actualValue && (
                      <div className="bg-slate-50 border border-slate-100 rounded-lg p-3 text-xs space-y-1.5">
                        <span className="block font-bold text-slate-500">Actual Achievement Tracker</span>
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-[11px]">
                          <div>
                            <span className="text-[9px] text-gray-400 font-bold block uppercase">Actual Value</span>
                            <span className="font-extrabold text-emerald-600">{kra.actualValue}</span>
                          </div>
                          {kra.achievementPercentage !== undefined && kra.achievementPercentage !== null && (
                            <>
                              <div>
                                <span className="text-[9px] text-gray-400 font-bold block uppercase">Achievement %</span>
                                <div className="flex flex-wrap items-center gap-1.5 mt-0.5">
                                  <span className="font-extrabold text-primary">{kra.achievementPercentage}%</span>
                                  <span className={`text-[9px] font-bold px-1.5 py-0.2 rounded border uppercase tracking-wider ${getRatingBadgeClass(getAchievementRating(kra.achievementPercentage))}`}>
                                    {getAchievementRating(kra.achievementPercentage)}
                                  </span>
                                </div>
                              </div>
                              <div>
                                <span className="text-[9px] text-gray-400 font-bold block uppercase">Earned Score Contribution</span>
                                <span className="font-extrabold text-slate-700">{kra.weightedScore?.toFixed(2)} / {kra.weightage}.00</span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Stage-wise Ratings and Feedbacks Matrix */}
                    <div className="space-y-3 text-xs">
                      {kra.evaluations && kra.evaluations.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                          {kra.evaluations.map((evalItem, eIdx) => {
                            const weightedContribution = (Number(evalItem.rating) / 5) * Number(kra.weightage);
                            const evaluatorName = getEvaluatorName(evalItem.stageKey, evalItem.evaluatorId);

                            return (
                              <div key={eIdx} className="bg-slate-50/60 border rounded-lg p-3 space-y-2 flex flex-col justify-between">
                                <div className="space-y-1">
                                  <span className="block font-bold text-[10px] uppercase tracking-wider text-slate-400">
                                    {evalItem.stageName || evalItem.stageKey}
                                  </span>
                                  <p className="text-slate-600 leading-relaxed italic">
                                    "{evalItem.feedback || "No feedback provided."}"
                                  </p>
                                </div>
                                <div className="pt-2 border-t flex flex-col gap-1">
                                  <div className="flex justify-between items-center text-[10px] text-slate-400 font-semibold">
                                    <span>Weighted Score:</span>
                                    <span className="font-bold text-slate-600">
                                      ({evalItem.rating} / 5) × {kra.weightage}% = {weightedContribution.toFixed(2)}
                                    </span>
                                  </div>
                                  <div className="flex justify-between items-center">
                                    <span className="text-[10px] font-semibold text-slate-400">Rating:</span>
                                    <span className="flex items-center gap-0.5 font-bold text-amber-600 bg-amber-50 px-2 py-0.5 rounded border border-amber-100">
                                      {evalItem.rating} <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
                                    </span>
                                  </div>
                                </div>
                                
                                <div className="flex justify-between items-center text-[9px] text-slate-400 border-t border-dashed pt-1.5 mt-1 font-semibold">
                                  <span>By: <strong>{evaluatorName}</strong></span>
                                  {evalItem.submittedAt && (
                                    <span>On: {new Date(evalItem.submittedAt).toLocaleDateString()}</span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <p className="text-slate-400 text-center italic py-2">No individual evaluations found for this KRA.</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t bg-slate-50 flex justify-end gap-3 shrink-0">
              {selectedReview.status !== "COMPLETED" && 
               !isSelfAssessmentStage(selectedReview) && (
                <button
                  onClick={() => handleSkipStage(selectedReview)}
                  disabled={skippingId === selectedReview._id}
                  className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold uppercase transition-colors"
                >
                  {skippingId === selectedReview._id ? "Bypassing..." : "Skip Active Stage"}
                </button>
              )}
              
              <button
                onClick={() => setSelectedReview(null)}
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
              >
                Close View
              </button>
            </div>

          </div>
        </div>
      )}

      {/* --- NEW: EDIT REVIEW MODAL --- */}
      {showEditReviewModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[80] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl border flex flex-col max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200 text-left">
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-10 h-10 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center shrink-0 border border-blue-100">
                  <Edit3 className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-950 text-sm sm:text-base leading-tight">Edit Review Sheet Goals</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">{editReviewForm.employeeName} ({editReviewForm.period})</p>
                </div>
              </div>
              <button onClick={() => setShowEditReviewModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-all"><X className="w-4 h-4" /></button>
            </div>

            <form onSubmit={handleEditReviewSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/30">
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
                    <input type="date" required value={editReviewForm.startDate} onChange={(e) => setEditReviewForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700" />
                  </div>
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
                    <input type="date" required value={editReviewForm.endDate} onChange={(e) => setEditReviewForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700" />
                  </div>
                </div>

                <div className="space-y-4 pt-2">
                  <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Review KRAs ({editReviewForm.kras.length})</span>
                    <button type="button" onClick={handleAutoSplitEditReviewWeights} className="text-[10px] text-primary hover:underline font-bold uppercase">Distribute Weights</button>
                  </div>

                  <div className="space-y-4 max-h-[300px] overflow-y-auto pr-1">
                    {editReviewForm.kras.map((k, idx) => (
                      <div key={idx} className="bg-white border rounded-xl p-4 shadow-sm space-y-3">
                        <div className="flex justify-between items-start gap-2">
                          <div>
                            <span className="inline-block bg-slate-100 text-slate-600 text-[8px] font-bold px-1.5 py-0.5 rounded uppercase">{k.category}</span>
                            <h4 className="font-bold text-gray-900 text-xs sm:text-sm mt-1">{k.name}</h4>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2.5 border-t">
                          <div>
                            <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Weightage (%)</label>
                            <input type="number" required value={k.weightage || ""} onChange={(e) => handleEditReviewKraChange(idx, "weightage", Number(e.target.value) || 0)} className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-bold bg-white" min={1} max={100} />
                          </div>
                          
                          <div>
                            <label className="block text-[9px] font-bold text-primary uppercase mb-1">Target Value *</label>
                            <input 
                              type="text" 
                              required 
                              value={k.targetValue || ""} 
                              onChange={(e) => handleEditReviewKraChange(idx, "targetValue", e.target.value)} 
                              className="w-full border border-red-200 rounded-lg px-2.5 py-1 text-xs font-bold bg-white" 
                              placeholder="e.g. 25 APIs" 
                            />
                          </div>

                          <div>
                            <label className="block text-[9px] font-bold text-gray-700 uppercase mb-1">Goal Direction *</label>
                            <div className="relative">
                              <select
                                value={k.metricType || "HIGHER_IS_BETTER"}
                                onChange={(e) => handleEditReviewKraChange(idx, "metricType", e.target.value)}
                                className="w-full border border-gray-200 rounded-lg pl-2 pr-5 py-1 text-xs font-bold bg-white appearance-none cursor-pointer h-[26px]"
                              >
                                <option value="HIGHER_IS_BETTER">Higher is Better</option>
                                <option value="LOWER_IS_BETTER">Lower is Better</option>
                              </select>
                              <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none stroke-[3]" />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="pt-2 border-t flex justify-between items-center text-xs font-bold">
                    <span className={totalEditReviewWeightSum === 100 ? "text-green-600" : "text-primary"}>Weightage Sum: {totalEditReviewWeightSum}%</span>
                    <span className="text-gray-400 uppercase text-[9px]">Required Total: 100%</span>
                  </div>
                </div>

              </div>

              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowEditReviewModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
                <button type="submit" disabled={updatingReview} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold uppercase hover:bg-blue-700">{updatingReview ? "Updating..." : "Save Updates"}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}